import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Sidebar.css';

const Sidebar = ({ currentPage, isDrawerOpen, onDrawerClose }) => {
  const { user, logout, isAdmin, isInvestor } = useAuth();
  const navigate = useNavigate();
  
  const photoManagementItems = [
    { name: 'Dashboard', icon: '📊', page: 'dashboard' },
    { name: 'Upload', icon: '📤', page: 'upload' },
    { name: 'Raw Picture', icon: '🖼️', page: 'raw-pictures' },
  ];
  const investorManagementItems = [
    { name: 'Investors', icon: '👥', page: 'admin/investors' },
    { name: 'Cars & Ownership', icon: '🚘', page: 'admin/vehicles' },
    { name: 'Report Uploads', icon: '📑', page: 'admin/finance' },
    { name: 'Investor View', icon: '💹', page: 'owner' },
    { name: 'Customer Support', icon: '💬', page: 'customer-support' },
    { name: 'Settings', icon: '⚙️', page: 'settings' },
  ];
  const workerMenuItems = [
    { name: 'Photos & Search', icon: '🖼️', page: 'dashboard' },
    { name: 'Upload Photos', icon: '📤', page: 'upload' },
    { name: 'Photos by Date', icon: '📅', page: 'raw-pictures' },
    { name: 'Additional Costs', icon: '💵', page: 'worker/vehicles' },
  ];

  const handleLinkClick = () => {
    // Close drawer on mobile when a link is clicked
    if (onDrawerClose) {
      onDrawerClose();
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      handleLinkClick();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <>
      {/* Overlay for mobile drawer */}
      {isDrawerOpen && (
        <div className="sidebar-overlay" onClick={onDrawerClose}></div>
      )}
      
      <div className={`sidebar ${isDrawerOpen ? 'drawer-open' : ''}`}>
        {/* Close button for mobile drawer */}
        <button className="drawer-close-btn" onClick={onDrawerClose} aria-label="Close navigation">
          ✕
        </button>
        
        <div className="sidebar-header">TW Rental</div>
        
        {/* Home - Always visible */}
        {!user && <Link
          to="/home"
          className={`menu-item ${currentPage === 'home' ? 'active' : ''}`}
          onClick={handleLinkClick}
        >
          <span className="menu-item-icon">🏠</span> Home
        </Link>}
        
        {isInvestor() && (
          <>
            <Link to="/owner" className={`menu-item ${currentPage === 'owner' || currentPage.startsWith('owner/vehicles/') ? 'active' : ''}`} onClick={handleLinkClick}>My Finances</Link>
            <Link to="/owner/cars" className={`menu-item ${currentPage === 'owner/cars' || currentPage.startsWith('owner/cars/') ? 'active' : ''}`} onClick={handleLinkClick}>My Cars</Link>
            <Link to="/owner/reports" className={`menu-item ${currentPage === 'owner/reports' ? 'active' : ''}`} onClick={handleLinkClick}>Reports</Link>
            <Link to="/owner/profile" className={`menu-item ${currentPage === 'owner/profile' ? 'active' : ''}`} onClick={handleLinkClick}>My Account</Link>
          </>
        )}

        {isAdmin() && <>
          <section className="sidebar-menu-section" aria-label="Photo Management">
            <h2 className="sidebar-section-title">Photo Management</h2>
            {photoManagementItems.map((item) => (
              <Link
                key={item.page}
                to={`/${item.page}`}
                className={`menu-item ${currentPage === item.page || currentPage.startsWith(`${item.page}/`) ? 'active' : ''}`}
                onClick={handleLinkClick}
              >
                <span className="menu-item-icon">{item.icon}</span> {item.name}
              </Link>
            ))}
          </section>
          <section className="sidebar-menu-section" aria-label="Investor Management">
            <h2 className="sidebar-section-title">Investor Management</h2>
            {investorManagementItems.map((item) => (
              <Link
                key={item.page}
                to={`/${item.page}`}
                className={`menu-item ${currentPage === item.page || currentPage.startsWith(`${item.page}/`) ? 'active' : ''}`}
                onClick={handleLinkClick}
              >
                <span className="menu-item-icon">{item.icon}</span> {item.name}
              </Link>
            ))}
          </section>
        </>}
        {(user?.role === 'worker' ? workerMenuItems : []).map((item, index) => (
          <Link 
            key={index} 
            to={`/${item.page}`}
            className={`menu-item ${currentPage === item.page || currentPage.startsWith(`${item.page}/`) ? 'active' : ''}`}
            onClick={handleLinkClick}
          >
            <span className="menu-item-icon">{item.icon}</span> {item.name}
          </Link>
        ))}
        
        {user && (
          <div className="sidebar-footer">
            <div className="user-info">
              <span className="user-name">{user?.name || user?.username}</span>
              <span className="user-role">{isAdmin() ? 'Admin' : user.role === 'worker' ? 'Worker' : 'Investor'}</span>
            </div>
            <button onClick={handleLogout} className="logout-button">
              <span className="menu-item-icon">🚪</span> Logout
            </button>
          </div>
        )}
        
        {/* Guest login option */}
        {!user && (
          <div className="sidebar-footer">
            <Link to="/login" className="login-link" onClick={handleLinkClick}>
             Sign In
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

export default Sidebar;
